import React from 'react';
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export const Goal4 = () => (
  <SVG
    width="50"
    height="50"
    viewBox="0 0 2250 2250"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path d="M2250,2250H0V0H2250Z" fill="#c72538" />
    <Path
      d="M1041.25,1855v-8.85q0-315-.14-630c0-5.74,1.64-8.85,6.63-11.73Q1244,1091.46,1440,978.13c3.16-1.82,6.38-3.52,10.33-5.7V1732Z"
      fill="#fff"
    />
    <Path
      d="M590.07,972.38c2.72,1.4,4.92,2.41,7,3.61q196.74,113.54,393.5,227c4.77,2.74,6.31,5.79,6.31,11.2q-.21,316-.12,632.08v8.42L590.07,1732Z"
      fill="#fff"
    />
    <Path
      d="M1494.23,969.94c15,11.83,28.66,22.56,42.19,33.47,1.12.91,1.5,3,1.78,4.6a30.48,30.48,0,0,1,.08,5.24q0,380.61.17,761.24c0,7.23-2.07,10-9.1,12.18q-174.88,54.66-349.57,110c-42.79,13.51-85.52,27.24-128.33,40.7-4.2,1.32-8.75,1.59-13.17,2.1-40.74,4.75-78.26-9.54-116.35-20Q716.75,1862.85,511.61,1806c-6.22-1.72-8.58-4-8.57-10.93q.31-391.12,0-782.25c0-6.18,1.89-10,6.81-13.63,12.22-9.05,24-18.73,37-29v802.14c16.78,4.74,33,9.38,49.25,13.92,131.63,36.74,263.13,74,395,109.71,24,6.5,49.09,3.39,73.61-4.63q210-68.74,420.54-136.1c6.72-2.16,9.14-4.83,9.13-12.22q-.35-381-.19-762Z"
      fill="#fff"
    />
    <Path
      d="M1721.56,1886.15c-8.48-29.49-16.54-57.36-24.52-85.26-6.86-24-13.81-47.9-20.33-72a76.87,76.87,0,0,1-2.84-19.8q-.22-328.07-.12-656.13v-10.06H1770v7.89q0,330.69-.25,661.38c0,9-3.22,18-5.71,26.85q-19.92,70.51-40.26,140.91C1723.33,1881.54,1722.68,1883.05,1721.56,1886.15Z"
      fill="#fff"
    />
    <Path
      d="M373.2,193.41V458.79h42.64v62H373.47v102H298.59V521.32H168.73c0-8.73.63-16.94-.11-25-2.48-26.82,4.13-51.17,15-75.78C216.09,347.1,246.84,272.93,278.22,199c1.49-3.5,2.54-6.48,7.65-6.43,27.49.28,55,.13,82.49.16A41.35,41.35,0,0,1,373.2,193.41Zm-74.95,88.75-1.18-.55q-31.6,88.39-63.28,177h64.46Z"
      fill="#fff"
    />
    <Path
      d="M660.72,354.88c1.62,1.89,2.63,3.89,4.25,4.83,13.81,8,9.85,18.87,4.83,30.38-11.61-6-20-15.44-27.58-25.56-2.58-3.43-5.06-5.26-9.69-5.41-26.45-.82-41.33-11.65-43.24-37.91-2.33-32-1.51-64.34.56-96.37,1.29-20.14,13.73-30.66,33.68-33.12a89,89,0,0,1,28.17.84c19.4,3.91,28.79,18.43,29.63,36.63,1.38,30.11,1.52,60.38.1,90.48C680.6,337.27,675.36,343,660.72,354.88Zm-9-80.16c0-14.49,0-29,0-43.48a23.66,23.66,0,0,0-.52-3.71c-1.6-10-6.39-14.43-15.78-14.53-9.58-.11-14.4,4-16.15,14a61.56,61.56,0,0,0-1,10.4c-.09,25-.14,50,0,75a62.14,62.14,0,0,0,1.85,14c1.43,5.89,5.52,9.09,11.69,10,12.39,1.76,19.35-4.38,19.81-18.93C652.11,303.22,651.76,289,651.74,274.72Z"
      fill="#fff"
    />
    <Path
      d="M676.14,625.35V461.11c21.46,1,42.92-2.57,63.91,3.4,17.64,5,25.3,18.77,25.7,35.57.71,29.9.88,59.9-1,89.72-1.32,21.45-14.66,33.72-35.92,35.29C711.53,626.36,694,625.35,676.14,625.35ZM706.78,483V604.47c4,0,7.43.14,10.89,0,11-.54,17-5.7,17.22-16.64.5-28.2.84-56.42.29-84.61-.33-16.29-5.46-20.17-22-20.17Z"
      fill="#fff"
    />
    <Path
      d="M1360.83,461.24c5.91,0,11.68-.52,17.28.26,2.11.3,4.57,3.25,5.59,5.56,11,24.87,21.66,49.85,32.46,74.79a16.42,16.42,0,0,0,4.71,6.83V461.83h24.86V625.74c-5.53,0-11.24.46-16.79-.25-1.9-.25-4.09-3.18-5-5.37-11.72-27.78-23.24-55.66-34.82-83.5-.56-1.36-1.19-2.69-2.66-6v94.58h-25.62Z"
      fill="#fff"
    />
    <Path
      d="M1340.51,544c-.8,16.17-.54,32.49-2.68,48.49-2.85,21.39-15.32,32.67-36.74,34.86a86.49,86.49,0,0,1-23.78-.79c-18.3-3.26-29.91-15.12-31.34-37.65a664.78,664.78,0,0,1,0-91.25c2.16-29.05,21-40.24,52-38.05,26.68,1.88,40.15,16.82,41.36,44.66.57,13.21.1,26.46.1,39.69Zm-31.77-.82h-.37c0-15.23.56-30.5-.18-45.7-.54-11-5.66-15.4-15.3-15.71-10.09-.33-16.42,4-16.67,15-.69,31.44-.12,62.91,0,94.36a13.38,13.38,0,0,0,.7,3.67c1.72,5.79,5.4,9.25,11.53,10.3,12.42,2.14,19.66-4,20.18-18.43S1308.74,557.65,1308.74,543.15Z"
      fill="#fff"
    />
    <Path
      d="M786.24,461.64h29v8.44c0,34.47-.12,68.95.11,103.42a97.48,97.48,0,0,0,2.33,20.72c1.67,7.36,7.57,11.15,15,10.93s12.69-3.9,14.19-11a108.29,108.29,0,0,0,2.19-21.49c.2-36.71.09-73.42.09-110.78h29.56v7.63c0,34.72.08,69.44-.07,104.16A101.08,101.08,0,0,1,877.06,593c-4.83,24.09-16.45,36.23-48.1,35-28-1.1-41.38-14.22-42.37-43.83C785.22,543.52,786.24,502.79,786.24,461.64Z"
      fill="#fff"
    />
    <Path
      d="M765.22,192.6h29.19c.13,2.78.35,5.21.35,7.63,0,35.74.31,71.48-.18,107.21a106.48,106.48,0,0,1-4.38,27.16c-3.36,11.87-11.82,19.4-23.93,22.5a68.89,68.89,0,0,1-37.7-.57c-15.17-4.63-21.92-16.49-24.7-31.06a99.25,99.25,0,0,1-1.81-17.86c-.16-36.73-.08-73.47-.07-110.2,0-1.46.18-2.92.29-4.76h29c0,2.8,0,5.67,0,8.55.16,37.22.26,74.44.58,111.66A46.79,46.79,0,0,0,734,326.09c2.17,7,7.39,10.24,14.8,10.17,7.16-.07,12.3-3.35,14-10.1A81.72,81.72,0,0,0,765.12,307c.22-35.23.1-70.47.1-105.71Z"
      fill="#fff"
    />
    <Path
      d="M959.85,564.35h31.21c-1.64,13-1.84,25.87-5.09,37.87-5,18.58-22.27,27.8-44.42,26-27.55-2.24-42-16.31-42.9-44.06-.87-26.91-1.08-53.92,0-80.82,1.58-38.35,41.84-58.4,74.08-37a33.62,33.62,0,0,1,12.9,17.47c3.28,11.72,3.75,24.22,5.48,37.07H960c0-8.1.21-15.79-.05-23.46-.35-10.18-4.62-14.89-13.51-15.59-9.43-.73-15.66,3.92-16.71,14.07-1.07,10.39-1.06,20.92-1.15,31.38-.14,18-.07,36,.1,53.94a61,61,0,0,0,1.4,11.87c1.82,8.75,7.34,12.89,16,12.37,8-.48,13.17-5.28,13.71-14C960.28,582.57,959.85,573.62,959.85,564.35Z"
      fill="#fff"
    />
    <Path
      d="M871.67,319.67h-28.1c-2.27,12.53-4.49,24.73-6.76,37.25H808.18c11.17-54.94,22.25-109.49,33.4-164.33h31.66l33.4,164.65c-8.87,0-17,.24-25.19-.22-1.43-.08-3.5-3-3.88-4.83C875.38,341.46,873.61,330.65,871.67,319.67Zm-24.76-21h21.4c-3.49-21.21-6.87-41.72-10.25-62.23l-1.1.12C853.64,257.09,850.32,277.6,846.91,298.69Z"
      fill="#fff"
    />
    <Path
      d="M1033.77,461.24c9.58,0,18.79-.18,28,.17,1.55,0,4.07,2.14,4.38,3.64q16.18,79.48,32,159a9.8,9.8,0,0,1-.18,1.66c-8,0-16.19.24-24.32-.23-1.44-.08-3.54-2.95-3.92-4.81-2.18-10.73-3.93-21.53-5.86-32.46h-28q-3.42,18.62-6.84,37.14H1000.4C1011.55,570.53,1022.61,516.12,1033.77,461.24Zm26.8,106.66c-3.5-21.11-6.86-41.38-10.21-61.64l-1.43.22c-3.28,20.3-6.55,40.61-9.91,61.42Z"
      fill="#fff"
    />
    <Path
      d="M1770,1004.81h-95.7c-.19-1.95-.53-3.83-.53-5.71,0-15.72-.11-31.45,0-47.18a47.58,47.58,0,0,1,48-47.18c26.43,0,48,21,48.23,47C1770.11,969.22,1770,986.66,1770,1004.81Z"
      fill="#fff"
    />
    <Path
      d="M590.62,461.51h68.63v21h-38v46.75h29.56V551H621.36v53.44H659.5v21H590.62Z"
      fill="#fff"
    />
    <Path
      d="M1135.61,193.53c8.32-.42,16.65-1.15,25-1,1.48,0,3.48,3.68,4.22,6,6,18.72,11.71,37.52,18.18,58.41,3-9.88,5.51-17.83,7.9-25.8,3.37-11.21,6.87-22.39,9.89-33.7,1.12-4.2,3.07-5.52,7.29-5.32,7.15.34,14.33.1,22.41.1-4,12.42-7.63,24-11.4,35.56-5.65,17.27-11.2,34.58-17.17,51.73a83.46,83.46,0,0,0-5,30.7c.53,15.41.14,30.84.14,46.65h-28.77c0-11.58-.88-23.06.18-34.36,2-21.56-4.41-41.24-11.16-61.09-7.53-22.15-14.47-44.49-21.67-66.75A7.36,7.36,0,0,0,1135.61,193.53Z"
      fill="#fff"
    />
    <Path d="M1123.72,483.81h-27V461.65h83.75v21.88h-25.74V625.29h-31Z" fill="#fff" />
    <Path
      d="M1135.61,193.53a7.36,7.36,0,0,1,0,1.15c-.76,2.24-2,4.45-2.18,6.74-.36,4.17-.11,8.39-.11,13.25H1107v142h-30.85V214.77H1049v-22c2.11-.21,4-.57,5.92-.57q36-.06,72,0C1129.79,192.28,1132.7,193.09,1135.61,193.53Z"
      fill="#fff"
    />
    <Path d="M990.78,356.86h-69.2V192.76h29.94V336.09h39.26Z" fill="#fff" />
    <Path d="M1222.76,625.48h-29V461.6h29Z" fill="#fff" />
    <Path d="M1036.14,357H1007V192.7h29.16Z" fill="#fff" />
  </SVG>
);
